import React from "react";
import {
  ClarificationModalWrapper,
  ImportStatusModalWrapper,
  DeleteModalWrapper,
  SendModalWrapper,
  SendResponsesModalWrapper,
  ImportValidationModalWrapper,
  CopyToSuppliersModalWrapper,
} from "./modals";

export const ClarificationsRegisterModals: React.FC = () => {
  return (
    <>
      <ClarificationModalWrapper />
      <ImportStatusModalWrapper />
      <DeleteModalWrapper />
      <SendModalWrapper />
      <SendResponsesModalWrapper />
      <ImportValidationModalWrapper />
      <CopyToSuppliersModalWrapper />
    </>
  );
};
